var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { transformStatus } from './status-transformer';
export var Status;
(function (Status) {
    Status["All"] = "All";
    Status["Canceled"] = "Canceled";
    Status["InProgress"] = "InProgress";
    Status["Submitted"] = "Submitted";
    Status["Done"] = "Done";
    Status["Failed"] = "Failed";
    Status["New"] = "New";
    Status["WaitForAction"] = "WaitForAction";
})(Status || (Status = {}));
export var StatusIcon;
(function (StatusIcon) {
    StatusIcon["InProgress"] = "/assets/icons/circle.svg";
    StatusIcon["Done"] = "/assets/icons/circle.svg";
    StatusIcon["Failed"] = "/assets/icons/canceled.svg";
    StatusIcon["WaitForAction"] = "/assets/icons/circle.svg";
})(StatusIcon || (StatusIcon = {}));
export var StatusClass;
(function (StatusClass) {
    StatusClass["InProgress"] = "in-progress";
    StatusClass["Done"] = "done";
    StatusClass["Failed"] = "canceled";
    StatusClass["WaitForAction"] = "exceptions";
})(StatusClass || (StatusClass = {}));
var OrderError = /** @class */ (function () {
    function OrderError(orderError) {
        this.date = new Date(orderError.date);
        this.description = orderError.description;
    }
    return OrderError;
}());
export { OrderError };
var OrderSourceFile = /** @class */ (function () {
    function OrderSourceFile(document) {
        var sourceFile = document.files.source;
        this.erpLink = document.data.erpLink;
        this.dueDate = document.data.dueDate && new Date(document.data.dueDate);
        this.invoiceDate = document.data.invoiceDate;
        this.id = sourceFile.id;
        this.name = sourceFile.name;
        this.targets = [];
        this.token = sourceFile.token;
        this.currency = document.data.currency || 'USD';
        this.total = Number(document.data.total);
        this.vendor = document.data.vendorName;
    }
    return OrderSourceFile;
}());
export { OrderSourceFile };
var OrderTargetFile = /** @class */ (function () {
    function OrderTargetFile(data) {
        this.id = data.id;
        this.name = data.name;
        this.token = data.token;
    }
    return OrderTargetFile;
}());
export { OrderTargetFile };
var Order = /** @class */ (function () {
    function Order(task) {
        var status = transformStatus(task.status);
        var files = task.documents && transformDocuments(task.documents);
        this.created = new Date(task.created);
        this.deadline = undefined;
        this.dueDate = files && files.length && minDueDate(files);
        this.email = task.email;
        this.id = task.id;
        this.serviceType = task.type;
        this.application = task.application;
        this.files = files;
        this.number = task.number;
        this.progress = task.progress;
        this.service = task.type;
        this.started = task.started ? new Date(task.started) : void 0;
        this.status = status;
        this.isExtraError = task.isExtraError;
    }
    return Order;
}());
export { Order };
function minDueDate(files) {
    var e_1, _a;
    var min = files[0].dueDate;
    try {
        for (var files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
            var file = files_1_1.value;
            if (min > file.dueDate) {
                min = file.dueDate;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return min;
}
function transformDocuments(documents) {
    var e_2, _a;
    var files = [];
    var findName = 'target';
    var _loop_1 = function (document_1) {
        if (!document_1.files.source) {
            return "continue";
        }
        var sourceFile = files.find(function (file) { return file.id === document_1.files.source.id; });
        if (!sourceFile) {
            sourceFile = new OrderSourceFile(document_1);
            files.push(sourceFile);
        }
        if (document_1.files.target) {
            var targetFullFileName = document_1.files.target.name;
            var targetFileName = targetFullFileName.substr(0, targetFullFileName.indexOf(targetFullFileName.split('.').pop()) - 1);
            var count = 1;
            for (var item in document_1.files) {
                if (item.indexOf(findName) > -1) {
                    if (item !== findName) {
                        var formatFile = document_1.files[item].name.split('.').pop();
                        document_1.files[item].name =
                            targetFileName + count + '.' + formatFile;
                        count++;
                    }
                    sourceFile.targets.push(new OrderTargetFile(document_1.files[item]));
                }
            }
        }
    };
    try {
        for (var documents_1 = __values(documents), documents_1_1 = documents_1.next(); !documents_1_1.done; documents_1_1 = documents_1.next()) {
            var document_1 = documents_1_1.value;
            _loop_1(document_1);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (documents_1_1 && !documents_1_1.done && (_a = documents_1.return)) _a.call(documents_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    (files || []).sort(function (a, b) { return (b.name > a.name ? -1 : 1); });
    return files;
}
export var openedOrders = {};
